import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const ProjectsBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Our" subTitle="Project" smText=' Our Project'></Breadcrumb>
        </>
    );
};

export default ProjectsBreadcrumb;